import { Link } from "gatsby";
import { ResourcesWrapper } from "../../../../src/collections/resources/Resources.style.js";
import Api from "../../../../src/collections/resources/articles/choosing-the-perfect-proxy/citrix-api-security-considerations-by-traffic-direction.svg";
import * as React from 'react';
export default {
  Link,
  ResourcesWrapper,
  Api,
  React
};